import React from "react";

import { Button } from "components/Button";
import Modal from "components/LegacyModal";
import Text from "components/Text";
import ZoningSummary from "components/guides/ZoningDetails/ZoningSummary";
import HelpBar from "components/projects/HelpBar";

import styles from "./ZoningDetailsModal.scss";

const ReturnButton = ({ onClick }) => (
  <Button onClick={onClick}>
    <Text t="guides.zoning.return_to_map" />
  </Button>
);

const ZoningDetailsModal = () => (
  <Modal CancelButton={ReturnButton} showCancel>
    <div className={styles.container}>
      <ZoningSummary />
    </div>
    <HelpBar />
  </Modal>
);

export default ZoningDetailsModal;
